<template>
	<v-select
		class="form__field"
		v-model="localValue"
		:items="options"
		:rules="validationRules"
		:label="label"
		:multiple="multiple"
	/>
</template>

<script>

export default {
	props: {
		value: [ String, Array ],
		label: String,
		options: Array,
		required: {
			type: Boolean,
			default: true
		},
		multiple: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		validationRules() {
			return this.required ? [v => !!v || this.$t("isRequired", { label: this.label })] : []
		},
		localValue: {
			get() {return this.value},
			set(localValue) { this.$emit('input', localValue)}
        },
	},
	i18n: {
		messages: {
			nl: {
				isRequired: "{label} is een verplicht veld"
			},
			en: {
				isRequired: "{label} is a required field"
			}
		}
	}

}
</script>
